import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { DefaultUrls } from 'src/assets/default.urls';
import { getPathFromRoot } from './utility/routing/route-path-from-root';
import { UNUSED_ARGS } from './utility/unused-arguments';

@Injectable({
  providedIn: 'root'
})
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private dashboardTree?: DetachedRouteHandle;

  public shouldDetach(route: ActivatedRouteSnapshot): boolean {
    if (this.getPathFromRoot(route).includes(DefaultUrls.route.dashboardCards)) {
      return true;
    }

    return false;
  }

  public store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void {
    if (!route.component) {
      return;
    }

    // force to remove the tooltip on route change
    while (document.getElementsByTagName('mat-tooltip-component').length > 0) {
      document.getElementsByTagName('mat-tooltip-component')[0].remove();
    }

    if (this.getPathFromRoot(route).includes(DefaultUrls.route.dashboardCards)) {
      this.dashboardTree = detachedTree;

      // The jsdoc of the store function mentions that storing `null` means erasing the previously
      // stored value. As we use `undefined` to indicate a missing detached route, set to `undefined`.
      if (detachedTree === null) {
        this.dashboardTree = undefined;
      }
    }
    UNUSED_ARGS(route, detachedTree);
  }

  public shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (!route.component) {
      return false;
    }
    if (this.dashboardTree !== undefined && this.getPathFromRoot(route).includes(DefaultUrls.route.dashboardCards)) {
      return true;
    }

    return false;
  }

  public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (!route.component) {
      return null;
    }
    if (this.dashboardTree !== undefined && this.getPathFromRoot(route).includes(DefaultUrls.route.dashboardCards)) {
      return this.dashboardTree;
    }

    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const futurePath = this.getPathFromRoot(future);
    const currPath   = this.getPathFromRoot(curr);

    if (futurePath.includes(DefaultUrls.route.thingieCreate)) {
      // Here we don't re-use the route to reset the wizard if we are already in it
      return false;
    }
    if (currPath.includes(DefaultUrls.route.deviceDetailBase) && futurePath.includes(DefaultUrls.route.deviceDetailBase)) {
      return true;
    }
    if (currPath.includes(DefaultUrls.route.dashboardCards) && futurePath.includes(DefaultUrls.route.dashboardStack)) {
      return true;
    }
    if (currPath.includes(DefaultUrls.route.dashboardStack) && futurePath.includes(DefaultUrls.route.dashboardCards)) {
      return true;
    }
    if (currPath.includes(DefaultUrls.route.thingieDetailBase)  && futurePath.includes(DefaultUrls.route.graphConfiguration) && futurePath.includes(DefaultUrls.route.thingieDetailBase)) {
      return true;
    }
    if (currPath.includes(DefaultUrls.route.graphConfiguration) && currPath.includes(DefaultUrls.route.thingieDetailBase) && futurePath.includes(DefaultUrls.route.thingieDetailBase)) {
      return true;
    }
    // if(currPath.includes('/thingies/create') && futurePath.includes('/dashboard/cards/stack')) {
    //   return true;
    // }

    return future.routeConfig === curr.routeConfig;
  }

  private getPathFromRoot(route: ActivatedRouteSnapshot) {
    return getPathFromRoot(route);
  }
}
